// generated from 1_349 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hightouchCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("hightouch_cohort_filter"),
  comparison_key: z.enum([
    "7", // 1_245 (92.29%)
    "8", // 104 (7.71%)
  ]),
  display_name: z.string(),
  // undefined: 250 (18.53%), defined 1_099 (81.47%)
  raw_value: z.string().optional(),
  value: z.object({
    id: z.string(),
    // null: 8 (0.59%)
    value: z.string().nullable(),
  }),
  varies_by_app_group: z.literal(true),
});
